import React from 'react';
import ReactApexChart from "react-apexcharts";
import {DarkStoreType} from "../../../common/types";

// Тип пропсов для компонента, ожидается массив данных по дарксторам
type DarkStoreTopPropsType = {
    data: DarkStoreType[]
}

// Основной компонент для отображения топа дарксторов
export const DarkStoreTop = ({data}: DarkStoreTopPropsType) => {
    // Массив значений для графика (количество товаров)
    const series = data.map((el) => el.kol_vo_tovarov)
    // Массив названий дарксторов для оси X (категории)
    const categories = data.map((el) => el.darkstora_y_lavka)

    // Опции для горизонтального столбчатого графика ApexCharts
    const options = {
        chart: {
            type: 'bar' as const,
            height: 350,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end' as const,
                horizontal: true,
                distributed: true,
            }
        },
        title: {
            text: 'ТОП 10',
            align: 'center' as const,
            margin: 20,
            style: {
                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
        ],
        xaxis: {
            categories: categories,
            labels: {
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',
                }
            }
        },
        dataLabels: {
            enabled: true,
            textAnchor: 'middle' as const,
            style: {
                colors: ['#fff']
            },
            formatter: function (val: any, opt: any) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
            },
            offsetX: 0,
            dropShadow: {
                enabled: true
            }
        },
        yaxis: {
            labels: {
                show: false
            }
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            x: {
                show: true,
            },
            y: {
                title: {
                    formatter: function () {
                        return 'Количество продуктов'
                    }
                }
            },
            marker: {
                show: true,
            },
        },
        legend: {
            show: false
        }
    }

    // Рендерим горизонтальный столбчатый график по топу дарксторов
    return (
        <div style={{height: '500px', color: "white" }}>
            <ReactApexChart
                options={options}
                series={[{data: series}]}
                type={'bar'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </div>
    );
};
